import React from "react";
import { Box, Typography } from "@mui/material";

const PartnerWithUsSection = () => {
  return (
    <Box
      sx={{
        py: { xs: 8, md: 10 },
        px: { xs: 2, md: 6 },
        backgroundColor: "#f9fafb",
        textAlign: "center",
      }}
    >
      <Typography
        variant="h4"
        sx={{
          fontWeight: 700,
          mb: 2,
          color: "text.primary",
        }}
      >
        Let’s Grow Together
      </Typography>

      <Typography
        variant="subtitle1"
        sx={{
          mb: 6,
          color: "text.secondary",
          maxWidth: "600px",
          mx: "auto",
        }}
      >
        Whether you serve local markets or global trade networks, Tuberway is
        your trusted partner in delivering quality and reliability from Nigerian
        soil.
      </Typography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "repeat(1, 1fr)",
            sm: "repeat(2, 1fr)",
            md: "repeat(2, 1fr)",
          },
          gap: 2,
          px: { xs: 0, sm: 4, md: 12 },
        }}
      >
        {/* Feature 1 */}

        <Box sx={{ border: "1px solid #D1D5DB", borderRadius: 2, p: 3 }}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
            For Local Partners
          </Typography>
          <Typography sx={{ color: "#666", mb: 2 }}>
            Retailers, restaurants, and food vendors. Get consistent supply and
            fair pricing.
          </Typography>
        </Box>

        {/* Feature 2 */}
        <Box sx={{ border: "1px solid #D1D5DB", borderRadius: 2, p: 3 }}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
            For Global Partners
          </Typography>
          <Typography sx={{ color: "#666", mb: 2 }}>
            Importers, distributors, and wholesalers, Partner with a verified
            Nigerian exporter.
          </Typography>
        </Box>
      </Box>

      {/* <Button
        variant="contained"
        sx={{
          backgroundColor: "#1E5667",
          textTransform: "none",
          fontWeight: 600,
          borderRadius: 2,
          px: 3,
          py: 1.5,
          mt: 3,
          "&:hover": { backgroundColor: "#2e7d32" },
        }}
      >
        Become a Partner →
      </Button> */}
    </Box>
  );
};

export default PartnerWithUsSection;
